var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.397,
    height: 26.397,
    viewBox: "0 0 26.397 26.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(-908.115 -201.363)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 13.199,
    cy: 13.199,
    r: 13.199,
    transform: "translate(908.115 201.363)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 2.175,
    cy: 2.175,
    r: 2.175,
    transform: "translate(919.139 206.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 4.037,
    height: 9.96,
    transform: "translate(919.295 212.877)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.d09b9f49fe06c031252586aec672896f.svg";
export { ForwardRef as ReactComponent };